
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_9334ItJ_45kEgSNLD4_45AtzuaZznTOaT6tO2wpJMik_PtKcYMeta } from "/codebuild/output/src2379137541/src/ark/pages/[...slug].vue?macro=true";
import { default as guiasNM7eP0MMe7hR07M5l66S5TV331Fn_iuzt9tEufoq9xcMeta } from "/codebuild/output/src2379137541/src/ark/pages/blog/guias.vue?macro=true";
import { default as indexYuUKJKoqNFxkjjTPEgEH9nxuU2Fg_45z7_JzBno2JoPNwMeta } from "/codebuild/output/src2379137541/src/ark/pages/blog/index.vue?macro=true";
import { default as temasQ0etbUFgJnB44gRTAjkVsGN5CHdj3_UmiJFqm_45J_45xC4Meta } from "/codebuild/output/src2379137541/src/ark/pages/blog/temas.vue?macro=true";
import { default as pesquisaggHAROnUdOJWgfwzq9kjspxBdcaaau_45j1pDxASLjcoQMeta } from "/codebuild/output/src2379137541/src/ark/pages/blog/pesquisa.vue?macro=true";
import { default as moradaeuHMK3EAw0ieZ4dkSajZfQwxezo49bAGLn1psfRH5OIMeta } from "/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue?macro=true";
import { default as habitantesaZNKZw_Uao6FBpFPQ2W1BzfvGftepRH_iy9uE8cgpYgMeta } from "/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue?macro=true";
import { default as escalao_45gaslym41WrtWOYQish7osSMl65mKO8q0CcRXwJCHPYgUdEMeta } from "/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue?macro=true";
import { default as tempo_45em_45casajpElhjcUb2VD_45g9JEygPdxdajQvknkQ1GgBcySRofkoMeta } from "/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue?macro=true";
import { default as tipo_45de_45produtoafupglpYGQJCUEpgkMUvvkxULVKgPshEN8_3INVAHxMMeta } from "/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue?macro=true";
import { default as comercializadoraje8e_XdQhhZE5gqPzdolEpbuZYZ1TDw_45KtHKrTgeDsMMeta } from "/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue?macro=true";
import { default as dados_45de_45contactoytQoemHBcCjnQnFAkG1CpRu_45ZpGCuDTUmHuLLwZ8XB0Meta } from "/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue?macro=true";
import { default as potencia_45contratada658Ket13pGLgvyMDtu_451ZXai_YeXKcYsjDjgUlGpSi8Meta } from "/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue?macro=true";
import { default as simular3tM2XlSWDKekH6LKQUZ1sEgezUda_45DA3nIgvwqVNDugMeta } from "/codebuild/output/src2379137541/src/ark/pages/energia/simular.vue?macro=true";
import { default as internet8ABh6_fCEox3GqeaOMBus9GXcDQ_u9dd6UCLRo2ueUAMeta } from "/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue?macro=true";
import { default as telemovelYZ7kWnm6uQH7w_45Zbshc3vpiNphyKPTrHF7jpSwX0yWcMeta } from "/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue?macro=true";
import { default as fidelizacaoH3k4n9hQyPpxXWYVXD02KgaXENuUYWFDURIKlOLr9dEMeta } from "/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue?macro=true";
import { default as operadora_45atual6tbVRsln5o16w43U866YyRtZ_b32V1Q_45zcraCtU_456HMMeta } from "/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue?macro=true";
import { default as dados_45de_45contactoRwp8MXNqKQmE4GbruWRy3CLxrgHCkaNlWlU_45P69R9VoMeta } from "/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue?macro=true";
import { default as simular3rd81raxcQ_d_0zkHSlPB_BkJR7oCtNGWzatfuzPjHUMeta } from "/codebuild/output/src2379137541/src/ark/pages/tv-net-voz/simular.vue?macro=true";
import { default as _91_46_46_46slug_93rcvdL_mRtzAywOl_q_45ORKVCrJT6HrbLW9J7j8pQ8TVUMeta } from "/codebuild/output/src2379137541/src/ark/pages/blog/autor/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93lqEBEtr87PeD91VWolEhRfzb27sa0dC_4500xDyTn3FHoMeta } from "/codebuild/output/src2379137541/src/ark/pages/blog/rubricas/[...slug].vue?macro=true";
import { default as resumoR706Hb5dFVJ9XlJ4_F_45u1seMwhzSVk5nRg17aqeHfq0Meta } from "/codebuild/output/src2379137541/src/ark/pages/depositos-a-prazo/resumo.vue?macro=true";
import { default as finalidadeKajxtMpfTiHpcYupVNww93amjjTKMkCFo4kMhP95ckEMeta } from "/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue?macro=true";
import { default as tipo_45de_45taxaxBVsO8EAVNNbsu1Fwi76ie1LwDml8B7EyX8bw8dmH9QMeta } from "/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue?macro=true";
import { default as dados_45de_45contactoRZXbwkPS2VFkopfiR1ISh5d5puiDx2gji9q_fq5xSVwMeta } from "/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue?macro=true";
import { default as estado_45do_45processobVd8njw7yPUqupmrBPyRHuzqCnr21i5U0FOvgB7wUlgMeta } from "/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue?macro=true";
import { default as situacao_45financeira3jX33E3kg8VjY1xbTFXmLWbKQofP4fhChEInGm3ufAgMeta } from "/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue?macro=true";
import { default as montante_45do_45emprestimoyE0bD0hffj4fyrCLxwHPbTb0E3CsNPZybINIMrUi0ucMeta } from "/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue?macro=true";
import { default as simularz_45gfxAN8uW1OZirn_80ULisL8eXwWAHsVFMfXpSsITAMeta } from "/codebuild/output/src2379137541/src/ark/pages/credito-habitacao/simular.vue?macro=true";
import { default as _91_46_46_46slug_93QTGRpjcINZzTo7wy0iqnOBrWMdynJw0_tFvQS0d3a9IMeta } from "/codebuild/output/src2379137541/src/ark/pages/simuladores/embed/[...slug].vue?macro=true";
import { default as resultadosu_sRk_45J9YdLdKCk4WaYc5IMhCu5nLIippWR06bDjnc8Meta } from "/codebuild/output/src2379137541/src/ark/pages/credito-habitacao/resultados.vue?macro=true";
import { default as indexGO7J5J_45AHiKxX_Ew_ZUEPGyzJnEJMf7WCj_45g7J4dMvAMeta } from "/codebuild/output/src2379137541/src/ark/pages/parcerias-imobiliarias/index.vue?macro=true";
import { default as _91_46_46_46slug_93GpPf42k2Vc6EDUH_45CyRI3cYEhbf8UAeJTUKCHXTf3McMeta } from "/codebuild/output/src2379137541/src/ark/pages/tv-net-voz/campanhas/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93p1_457bkXAKRNW_4A9pxwVQH5hxBZHjHLUT_45hvBe7sqroMeta } from "/codebuild/output/src2379137541/src/ark/pages/parcerias-imobiliarias/[...slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src2379137541/src/ark/pages/[...slug].vue")
  },
  {
    name: "blog-guias",
    path: "/blog/guias",
    component: () => import("/codebuild/output/src2379137541/src/ark/pages/blog/guias.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/codebuild/output/src2379137541/src/ark/pages/blog/index.vue")
  },
  {
    name: "blog-temas",
    path: "/blog/temas",
    component: () => import("/codebuild/output/src2379137541/src/ark/pages/blog/temas.vue")
  },
  {
    name: "blog-pesquisa",
    path: "/blog/pesquisa",
    component: () => import("/codebuild/output/src2379137541/src/ark/pages/blog/pesquisa.vue")
  },
  {
    name: "energia-simular",
    path: "/energia/simular",
    meta: { ...(simular3tM2XlSWDKekH6LKQUZ1sEgezUda_45DA3nIgvwqVNDugMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src2379137541/src/ark/pages/energia/simular.vue"),
    children: [
  {
    name: "energia-simular-morada",
    path: "morada",
    component: () => import("/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue")
  },
  {
    name: "energia-simular-habitantes",
    path: "habitantes",
    component: () => import("/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue")
  },
  {
    name: "energia-simular-escalao-gas",
    path: "escalao-gas",
    component: () => import("/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue")
  },
  {
    name: "energia-simular-tempo-em-casa",
    path: "tempo-em-casa",
    component: () => import("/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue")
  },
  {
    name: "energia-simular-tipo-de-produto",
    path: "tipo-de-produto",
    component: () => import("/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue")
  },
  {
    name: "energia-simular-comercializadora",
    path: "comercializadora",
    component: () => import("/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue")
  },
  {
    name: "energia-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue")
  },
  {
    name: "energia-simular-potencia-contratada",
    path: "potencia-contratada",
    component: () => import("/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue")
  }
]
  },
  {
    name: "tv-net-voz-simular",
    path: "/tv-net-voz/simular",
    meta: { ...(simular3rd81raxcQ_d_0zkHSlPB_BkJR7oCtNGWzatfuzPjHUMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src2379137541/src/ark/pages/tv-net-voz/simular.vue"),
    children: [
  {
    name: "tv-net-voz-simular-internet",
    path: "internet",
    component: () => import("/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue")
  },
  {
    name: "tv-net-voz-simular-telemovel",
    path: "telemovel",
    component: () => import("/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue")
  },
  {
    name: "tv-net-voz-simular-fidelizacao",
    path: "fidelizacao",
    component: () => import("/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue")
  },
  {
    name: "tv-net-voz-simular-operadora-atual",
    path: "operadora-atual",
    component: () => import("/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue")
  },
  {
    name: "tv-net-voz-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue")
  }
]
  },
  {
    name: "blog-autor-slug",
    path: "/blog/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src2379137541/src/ark/pages/blog/autor/[...slug].vue")
  },
  {
    name: "blog-rubricas-slug",
    path: "/blog/rubricas/:slug(.*)*",
    component: () => import("/codebuild/output/src2379137541/src/ark/pages/blog/rubricas/[...slug].vue")
  },
  {
    name: "depositos-a-prazo-resumo",
    path: "/depositos-a-prazo/resumo",
    component: () => import("/codebuild/output/src2379137541/src/ark/pages/depositos-a-prazo/resumo.vue")
  },
  {
    name: "credito-habitacao-simular",
    path: "/credito-habitacao/simular",
    meta: { ...(simularz_45gfxAN8uW1OZirn_80ULisL8eXwWAHsVFMfXpSsITAMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src2379137541/src/ark/pages/credito-habitacao/simular.vue"),
    children: [
  {
    name: "credito-habitacao-simular-finalidade",
    path: "finalidade",
    component: () => import("/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue")
  },
  {
    name: "credito-habitacao-simular-tipo-de-taxa",
    path: "tipo-de-taxa",
    component: () => import("/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue")
  },
  {
    name: "credito-habitacao-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue")
  },
  {
    name: "credito-habitacao-simular-estado-do-processo",
    path: "estado-do-processo",
    component: () => import("/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue")
  },
  {
    name: "credito-habitacao-simular-situacao-financeira",
    path: "situacao-financeira",
    component: () => import("/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue")
  },
  {
    name: "credito-habitacao-simular-montante-do-emprestimo",
    path: "montante-do-emprestimo",
    component: () => import("/codebuild/output/src2379137541/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue")
  }
]
  },
  {
    name: "simuladores-embed-slug",
    path: "/simuladores/embed/:slug(.*)*",
    meta: _91_46_46_46slug_93QTGRpjcINZzTo7wy0iqnOBrWMdynJw0_tFvQS0d3a9IMeta || {},
    component: () => import("/codebuild/output/src2379137541/src/ark/pages/simuladores/embed/[...slug].vue")
  },
  {
    name: "credito-habitacao-resultados",
    path: "/credito-habitacao/resultados",
    meta: resultadosu_sRk_45J9YdLdKCk4WaYc5IMhCu5nLIippWR06bDjnc8Meta || {},
    component: () => import("/codebuild/output/src2379137541/src/ark/pages/credito-habitacao/resultados.vue")
  },
  {
    name: "parcerias-imobiliarias",
    path: "/parcerias-imobiliarias",
    component: () => import("/codebuild/output/src2379137541/src/ark/pages/parcerias-imobiliarias/index.vue")
  },
  {
    name: "tv-net-voz-campanhas-slug",
    path: "/tv-net-voz/campanhas/:slug(.*)*",
    meta: _91_46_46_46slug_93GpPf42k2Vc6EDUH_45CyRI3cYEhbf8UAeJTUKCHXTf3McMeta || {},
    component: () => import("/codebuild/output/src2379137541/src/ark/pages/tv-net-voz/campanhas/[...slug].vue")
  },
  {
    name: "parcerias-imobiliarias-slug",
    path: "/parcerias-imobiliarias/:slug(.*)*",
    meta: _91_46_46_46slug_93p1_457bkXAKRNW_4A9pxwVQH5hxBZHjHLUT_45hvBe7sqroMeta || {},
    component: () => import("/codebuild/output/src2379137541/src/ark/pages/parcerias-imobiliarias/[...slug].vue")
  }
]